// @ts-nocheck
import { fabric } from 'fabric';
import { ANNOTATION_TYPE } from '../../../config';

let RectangleSelection;

(function () {
  const STROKE = {
    selectable: false,
    hasControls: false,
    hasBorders: false,
    hasRotatingPoint: false,
    selection: false,
    skipTargetFind: false,
    editable: false,
    fill: 'rgba(0, 0, 255, .1)',
    stroke: 'rgba(0, 0, 255, .5)',
  };

  RectangleSelection = function (
    cv: any,
    points: any,
    offsetX: any,
    config: any,
    verticalChannelPlacement: any,
    channelIndex: any,
  ) {
    this.type = ANNOTATION_TYPE.RECT_SELECT;
    this.canvas = cv;
    this.channelIndex = channelIndex;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
    this.x1 = points.x1;
    this.x2 = points.x2;
    this.height = 50;
    this.width = this.x2 - this.x1;
    this.left = Math.min(this.x1, this.x2);
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.xr = offsetX + this.x1 * this.spp;
  };

  RectangleSelection.prototype.updateChannelIdx = function (channelIndex: any) {
    this.channelIndex = channelIndex;
  };

  RectangleSelection.prototype.draw = function () {
    this.rect = new fabric.Rect({
      left: this.left,
      top: this.verticalChannelPlacement[this.channelIndex] - this.height / 2, // half-height
      width: this.width,
      height: this.height,
      ...STROKE,
    });
    this.canvas.add(this.rect);
  };

  RectangleSelection.prototype.render = function () {
    if (
      !(
        (this.x1 < 0 && this.x2 < 0) ||
        (this.x1 > this.config.width && this.x2 > this.config.width)
      )
    ) {
      this.canvas.renderAll();
    }
  };

  RectangleSelection.prototype.update = function (delta: any, isScrolling: any, leValue: any) {
    this.x2 = !isScrolling ? this.x2 + delta.dx : leValue;
    const startH = Math.min(this.x1, this.x2);
    const endH = Math.max(this.x1, this.x2);
    this.width = endH - startH;
    this.left = startH;
    this.rect.set({
      width: this.width,
      left: this.left,
      height: this.height,
      top: this.verticalChannelPlacement[this.channelIndex] - this.height / 2,
    });
  };

  RectangleSelection.prototype.scroll = function (offsetX: any, displayedChannelsArr: any) {
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      // if (this.channelIndex === displayedChannelsArr[i]) {
      if (this.channelIndex === i) {
        const d = this.x2 - this.x1;
        this.x1 = (this.xr - offsetX) / this.spp;
        this.x2 = this.x1 + d;
        const startH = Math.min(this.x1, this.x2);
        const endH = Math.max(this.x1, this.x2);
        this.width = endH - startH;
        this.rect.set({
          width: this.width,
          left: startH,
        });
        break;
      }
    }
  };

  RectangleSelection.prototype.select = function () {};

  RectangleSelection.prototype.deselect = function () {};

  RectangleSelection.prototype.delete = function () {
    this.canvas.remove(this.rect);
  };
})();

export { RectangleSelection };
export default { RectangleSelection };
